export const SEARCH_FORM_SUBMIT = 'STAFF.QUESTIONNAIRES.SEARCH_FORM_SUBMIT';
export const SORT_CHANGE = 'STAFF.QUESTIONNAIRES.SORT_CHANGE';
export const PAGE_CHANGE = 'STAFF.QUESTIONNAIRES.PAGE_CHANGE';
export const FETCH_LIST = 'STAFF.QUESTIONNAIRES.FETCH_LIST';
export const FETCH_ONE = 'STAFF.QUESTIONNAIRE.FETCH_ONE';
export const CLEAR_ONE = 'STAFF.QUESTIONNAIRE.CLEAR_ONE';
export const FETCH_PREVIEW = 'STAFF.QUESTIONNAIRE.FETCH_PREVIEW';
export const CLEAR_PREVIEW = 'STAFF.QUESTIONNAIRE.CLEAR_PREVIEW';
